import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=28e3f7ed&scoped=true&"
import script from "./ChatWindow.vue?vue&type=script&lang=js&"
export * from "./ChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=28e3f7ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3f7ed",
  null
  
)

export default component.exports